import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { BackofficeRoleGuard } from './guards/backoffice-role.guard';
import { LoginComponent } from './view/login/login.component';
import { PolicyTermsComponent } from './view/login/policy-terms/policy-terms.component';
import { PreloginComponent } from './view/login/prelogin/prelogin.component';
import { QrCodeComponent } from './view/qr-code/qr-code.component';

const routes: Routes = [
  { path: "prelogin", component: PreloginComponent},
  { path: "login", component: LoginComponent},
  { path: "policy-terms", component: PolicyTermsComponent},
  { path: "backoffice", canActivate:[BackofficeRoleGuard],
    loadChildren: () => import('./view/backoffice/backoffice.module').then( m => m.BackofficeModule)
  },
  { path: "app", canActivate:[AuthGuard],
    loadChildren: () => import('./view/webapp/webapp.module').then( m => m.WebappModule)
  },
  { path: "qr", component: QrCodeComponent},
  {path: '**', redirectTo: "/prelogin"},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
